<template>
  <div class="flex-column" style="background-color: white;overflow: hidden">
    <top-bar :title="title" :show-back="true"></top-bar>
    <div style="padding: 10px">
      <div ref="container" class="v-waterfall-content">
        <div ref="left" class="left"></div>
        <div ref="right" class="right"></div>
      </div>
    </div>
    <div class="suspension" @click="back"></div>
  </div>
</template>

<script>

import {getXXTList} from "@/api/home";
import {VUE_APP_API_URL} from "@utils";
import topBar from "../top-bar/index2";
import defImg from "@assets/home_new/def.png";
import back from "@assets/home_new/back.png";

export default {
  name: "children",
  components: {topBar},
  data() {
    return {
      route: {},
      title: "青春榜样",
      imgsArr: undefined,
      username: "gh_2d3b90474b81",
      image: "",
      show: true,
      show1: false,
      timeId: null,
      div: {},
      left: {},
      right: {},
      imgWidth: 220,
      count: 0,
      gap: 10,
      defImg: defImg,
      back1: back
    };
  },
  created() {
    this.route = this.$route.query;
  },
  mounted() {
    this.div = this.$refs.container;
    this.left = this.$refs.left;
    this.right = this.$refs.right;
    this.imgWidth = this.div.clientWidth / 2 + "px";
    this.getData(this.route.themeId);
  },
  destroyed() {
  },
  methods: {
    back() {
      if (this.parent) {
        // if (this.parent.Theme_id+"" === this.route.themeId) {
        //   this.$tip({
        //     message: "当前是最上层",
        //   });
        //   return;
        // }
        // this.getData(this.parent.Theme_parent_id);
        this.$router.go(-1);
      }

    },
    creatImg(err) {
      //创建img元素
      if (this.count >= this.imgsArr.length) {
        return;
      }
      var width = this.left.clientWidth;
      var children = this.imgsArr[this.count]
      var src = children.src; //循环拿到照片
      var leftHeight = 0;
      for (const children of this.left.children) {
        leftHeight = leftHeight + children.clientHeight + this.gap;
      }
      var rightHeight = 0;
      for (const children of this.right.children) {
        rightHeight = rightHeight + children.clientHeight + this.gap;
      }
      var div = document.createElement("div"); //创建img元素
      div.className = "item-group";
      div.style.width = width + "px";
      div.style.height = "auth"; //设置图宽度
      div.style.backgroundColor = "#ffffff";
      div.style.marginTop = this.gap + "px"; //设置图宽度
      div.style.borderRadius = "0.2rem";
      var img = document.createElement("img"); //创建img元素
      img.src = src; //设置图片的src地址
      // if (children.children) {
      //   img.src = require("@assets/home_new/file.png");
      // }
      if (err) {
        img.src = _this.defImg;
      }
      img.style.width = width + "px"; //设置图宽度
      img.style.height = "auth"; //设置图宽度
      img.style.marginTop = this.gap + "px"; //设置图宽度
      img.style.objectFit = "fill";
      img.style.whiteSpace;
      img.style.borderRadius = "0.2rem";
      img.id = this.count;
      div.appendChild(img);
      var div2 = document.createElement("div"); //创建img元素
      div2.style.width = width + "px";
      div2.innerText = this.imgsArr[this.count].Prod_name;
      div2.style.textAlign = "center"
      div2.style.fontSize = "0.25rem";
      div2.style.fontFamily = "JDZY";
      div.appendChild(div2);
      if (leftHeight <= rightHeight) {
        this.left.appendChild(div);
      } else {
        this.right.appendChild(div);
      }
      //排列每一张图片
      var _this = this;
      img.onclick = function (res) {
        var obj1 = _this.imgsArr[res.currentTarget.id];
        // if (obj1.children) {
        //   // _this.getData(obj1.Theme_id);
        // }
        window.location = src;
      };
      // img.alt = require("@assets/home_new/def.png")
      img.onload = function () {
        _this.count++;
        _this.creatImg();
      };
      // img.onerror = function (e) {
      //   console.log(e)
      //   _this.creatImg("err");
      // };
    },
    getData(themeId) {
      this.count = 0;
      console.log(themeId)
      var _this = this;
      getXXTList({themeId: themeId})
          .then(res => {
            if (res.code === 1000) {
              _this.parent = res.result.parent
              _this.title = res.result.parent.Theme_name
              _this.imgsArr = _this.initImgsArr(res.result.parent.items);
              _this.left.innerHTML = "";
              _this.right.innerHTML = "";
              console.log(_this.imgsArr)
              _this.creatImg()
            }
          })
          .catch(e => {
            console.info(e);
          });
    },
    clickFn(event, {index, value}) {
      this.getData(value.themeId);
    },
    initImgsArr(imgsArr) {
      var arr = [];
      var _this = this;
      for (let i = 0; i < imgsArr.length; i++) {
        const argument = imgsArr[i];
        if (argument.logo_img) {
          // 有儿子的是文件夹
          argument.src = argument.logo_img
              ? `${VUE_APP_API_URL}/home/getXXTImage?id=` + argument.logo_img
              : _this.defImg;
          argument.link = "";
          argument.info =
              argument.Prod_name;
        } else {
          // 有儿子的是文件夹
          argument.src = argument.Storage_position
              ? `${VUE_APP_API_URL}/home/getXXTImage?id=` + argument.Storage_position
              : _this.defImg;
          argument.link = "";
          argument.info =
              argument.Prod_name;
        }
        arr.push(argument);
      }
      return arr;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.v-waterfall-content {
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: calc(100vh - 2.7rem);
  gap: 10px;
  padding-bottom: 1.2rem;
}

.left {
  width: calc(50% - 5px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: auto;
}

.right {
  width: calc(50% - 5px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: auto;
}

/* 图片样式 */
.v-waterfall-content img {
  transition: all 0.5s;
  width: 220px;
}

.suspension {
  position: fixed;
  width: 1.2rem;
  height: 1.2rem;
  bottom: 1.4rem;
  right: 1rem;
  background: url(../../assets/home_new/back.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
</style>
